import React from 'react';
import {
  Box, Button, Card, CardContent, CircularProgress, Typography, makeStyles,
} from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles(theme => ({
  page: {
    boxSizing: 'border-box',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
    padding: theme.spacing(3),
    width: '100%',
    [theme.breakpoints.down('sm')]: { padding: theme.spacing(2) },
  },
  header: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    minWidth: 0,
    [theme.breakpoints.down('xs')]: { flexDirection: 'column' },
  },
  headerCopy: { maxWidth: 760, minWidth: 0 },
  title: { marginBottom: theme.spacing(.5) },
  actions: {
    display: 'flex',
    flexShrink: 0,
    gap: theme.spacing(1),
    [theme.breakpoints.down('xs')]: { width: '100%', '& > *': { flex: 1 } },
  },
  state: { marginTop: theme.spacing(2) },
  stateContent: { alignItems: 'center', display: 'flex', gap: theme.spacing(1.5), minHeight: 88 },
  emptyContent: { padding: theme.spacing(4), textAlign: 'center' },
  constrained: { overflow: 'hidden', width: '100%' },
  table: { maxWidth: '100%', overflowX: 'auto' },
  toolbar: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    '& .MuiFormControl-root': { minWidth: 150 },
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
      '& .MuiFormControl-root': { width: '100%' },
    },
  },
}));

export const useCommercialUiStyles = useStyles;

export function CommercialPage({ children, maxWidth }) {
  const classes = useStyles();
  return <main className={classes.page} style={maxWidth ? { maxWidth } : undefined}>{children}</main>;
}

export function CommercialPageHeader({ title, description, eyebrow, actions }) {
  const classes = useStyles();
  return <header className={classes.header}>
    <div className={classes.headerCopy}>
      {eyebrow && <Typography variant="overline" color="textSecondary">{eyebrow}</Typography>}
      <Typography className={classes.title} variant="h4">{title}</Typography>
      <Typography color="textSecondary">{description}</Typography>
    </div>
    {actions && <div className={classes.actions}>{actions}</div>}
  </header>;
}

export function CommercialLoading({ label = 'Loading commercial data…' }) {
  const classes = useStyles();
  return <Card className={classes.state} variant="outlined" role="status" aria-live="polite">
    <CardContent className={classes.stateContent}><CircularProgress size={24} /><Typography>{label}</Typography></CardContent>
  </Card>;
}

export function CommercialEmpty({ title, description, action }) {
  const classes = useStyles();
  return <Box className={classes.emptyContent}>
    <Typography variant="h6" gutterBottom>{title}</Typography>
    <Typography color="textSecondary" paragraph>{description}</Typography>
    {action}
  </Box>;
}

export function CommercialError({ title = 'Commercial data could not be loaded', error, onRetry }) {
  const classes = useStyles();
  return <Card className={classes.state} variant="outlined" role="alert"><CardContent>
    <Typography color="error" gutterBottom>{title}</Typography>
    {error && <Typography color="textSecondary" paragraph>{error.message || String(error)}</Typography>}
    {onRetry && <Button onClick={onRetry} startIcon={<RefreshIcon />}>Retry</Button>}
  </CardContent></Card>;
}
